export enum PLAN_TIER {
  PLUS = 'plus',
  FREE = 'free',
  PRO_2022 = 'pro_2022',
  PREMIUM_2022 = 'premium_2022',
}

export enum BILLING {
  YEARLY = 'yearly',
  MONTHLY = 'monthly',
}

export enum LOCATION {
  BILLING_DETAILS = 'billing_details',
  PAYMENT_METHOD = 'payment_method',
  PAYMENT_INCOMPLETE = 'payment_incomplete',
}

export type LocationType =
  | LOCATION.BILLING_DETAILS
  | LOCATION.PAYMENT_METHOD
  | LOCATION.PAYMENT_INCOMPLETE;
